<template>
    <div>
      <client-list></client-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  